import script from "./Ipadphone.vue?vue&type=script&setup=true&lang=js"
export * from "./Ipadphone.vue?vue&type=script&setup=true&lang=js"

import "./Ipadphone.vue?vue&type=style&index=0&id=5fe05b3e&lang=less&scoped=true"

import exportComponent from "D:\\openAi\\chinese-academy-of-sciences-home\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5fe05b3e"]])

export default __exports__